import * as userHelpers from 'resources/user/user.helpers';

import {
  bottomTabs,
  sideBarTabs,
  settingsTab,
  transactionTabs,
  auditTabs,
  pipelineTabs,
  teamMemberTabs,
  clientProfileTabs,
  uploadDocumentsModalTabs,
} from './tabs';

// TODO: rework this in more elegant way
const pageContentOffsets = {
  withoutTop: 'withoutTopOffset', // 0 16px 22px / 0 32px 22px
  notSet: 'notSetOffset',
  default: 'defaultOffset', // 22px 16px / 22px 32px
};

export const tabs = {
  bottomTabs,
  sideBarTabs,
  settingsTab,
  transactionTabs,
  pipelineTabs,
  teamMemberTabs,
  auditTabs,
  clientProfileTabs,
  uploadDocumentsModalTabs,
};

export const scope = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  NONE: null,
};

export const layout = {
  MAIN: 'main',
  BOX: 'box',
  UNAUTHORIZED: 'unauthorized',
  MARKETING: 'marketing',
  NONE: null,
};

export const path = {
  home: '/',
  404: '/_error',
  signIn: '/sign-in',
  signUp: '/sign-up',
  signUpInvitee: '/sign-up-invitee',
  onboarding: '/onboarding',
  setupAccountInfo: '/setup-account-info',
  listedKits: '/listed-kits',
  newKit: '/listed-kits/new',
  newKitBasicDetails: '/listed-kits/new/[flow]/basic-details',
  newKitSelectExisting: '/listed-kits/new/use-existing/select',
  newKitImportTasks: '/listed-kits/new/import-tasks/import',
  emailTemplates: '/email-templates',
  newEmailTemplate: '/email-templates/new',
  editEmailTemplate: '/email-templates/[id]/edit',
  emailTemplatesFolder: '/email-templates/folders/[folderId]',
  editEmailTemplateInFolder: '/email-templates/folders/[folderId]/[id]/edit',
  listedKitDetails: '/listed-kit-details',
  clients: '/clients',
  clientProfile: '/client-profile/[id]',
  editClientProfile: '/client-profile/[id]/edit',
  account: '/account',
  editAccount: '/account/edit',
  serviceProvidersList: '/service-providers-list',
  publicServiceProvidersList: '/public-service-providers-list',
  tasks: '/tasks',
  teams: '/teams',
  eSignTemplates: '/e-signature-templates',
  editESignTemplate: '/e-signature-templates/[id]/edit',
  teamMemberProfile: '/teams/member/[memberId]',
  editTeamMemberDetails: '/teams/member/[memberId]/edit',
  teamProfile: '/teams/[teamId]',
  editTeamProfile: '/teams/[teamId]/edit',
  agentProfile: '/agent-profile',
  publicAgentProfile: '/public-agent-profile',
  publicDocuments: '/public-documents',
  transactions: '/transactions',
  newTransactionOptions: '/transactions/new/options',
  newTransactionScanComplete: '/transactions/new/scan-complete',
  newTransactionScanReview: '/transactions/new/review',
  newTransaction: '/new-transaction',
  transaction: '/transaction/[id]',
  transactionTemplatedEmail: '/transaction/[id]/templated-email',
  editTransaction: '/transaction/[id]/edit',
  manageTransactionClients: '/transaction/[id]/manage-clients',
  signDocument: '/transaction/[id]/sign-document/[documentId]',
  signDocumentSubmitted: '/transaction/[id]/sign-document/[documentId]/submitted',
  signDocumentGroup: '/transaction/[id]/sign-document-group/[documentGroupId]',
  signDocumentGroupSubmitted: '/transaction/[id]/sign-document-group/[documentGroupId]/submitted',
  confirmTransactionSigners: '/transaction/[id]/confirm-signers',
  auditTransaction: '/audit/[auditId]',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  expiredLink: '/expired-link',
  publicNewLead: '/public-new-lead',
  integrations: '/integrations',
  shortLinks: '/short-links',
  shortLink: '/short-links/[hash]',
  closePage: '/close-page',
  advancedFields: '/advanced-fields',
  gmailAddedCallback: '/gmail-added-callback',
  milestoneTemplateDetails: '/milestone-template-details',
};

const getPublicPages = (user) => ({
  shortLinks: {
    path: path.shortLinks,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  shortLink: {
    path: path.shortLink,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  signIn: {
    path: path.signIn,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  signUp: {
    path: path.signUp,
    scope: scope.PUBLIC,
    layout: layout.NONE,
    pageContentOffset: pageContentOffsets.notSet,
  },
  expiredLink: {
    path: path.expiredLink,
    scope: scope.NONE,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  signUpInvitee: {
    path: path.signUpInvitee,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
    pageContentOffset: pageContentOffsets.withoutTop,
  },
  forgotPassword: {
    path: path.forgotPassword,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
  },
  resetPassword: {
    path: path.resetPassword,
    scope: scope.NONE,
    layout: layout.UNAUTHORIZED,
  },

  publicAgentProfile: {
    path: path.publicAgentProfile,
    scope: user ? scope.PRIVATE : scope.PUBLIC,
    layout: user ? layout.MAIN : layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  publicNewLead: {
    path: path.publicNewLead,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    desktopLayout: layout.BOX,
  },
  publicServiceProvidersList: {
    path: path.publicServiceProvidersList,
    scope: scope.PUBLIC,
    layout: layout.UNAUTHORIZED,
    pageContentOffset: pageContentOffsets.withoutTop,
  },
  publicDocuments: {
    path: path.publicDocuments,
    scope: user ? scope.PRIVATE : scope.PUBLIC,
    layout: user ? layout.MAIN : layout.MARKETING,
    tab: tabs.bottomTabs.MORE,
    pageContentOffset: pageContentOffsets.withoutTop,
  },
  404: {
    path: path['404'],
    scope: scope.NONE,
    layout: layout.NONE,
  },
});

const commonUserPages = {
  setupAccountInfo: {
    path: path.setupAccountInfo,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    desktopLayout: layout.BOX,
    hideEmailVerificationToast: true,
  },
  home: {
    path: path.home,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.HOME,
    sideBarTab: tabs.sideBarTabs.HOME,
  },
  tasks: {
    path: path.tasks,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.TASKS,
    sideBarTab: tabs.sideBarTabs.TASKS,
  },
  transactions: {
    path: path.transactions,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
  },
  serviceProvidersList: {
    path: path.serviceProvidersList,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.SERVICE_PROVIDERS_LIST,
    pageContentOffset: pageContentOffsets.notSet,
  },
  transaction: {
    path: path.transaction,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    pageContentOffset: pageContentOffsets.withoutTop,
  },
  gmailAddedCallback: {
    path: path.gmailAddedCallback,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
  },
};

const realtorPages = {
  listedKits: {
    path: path.listedKits,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  newKit: {
    path: path.newKit,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  newKitBasicDetails: {
    path: path.newKitBasicDetails,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  newKitSelectExisting: {
    path: path.newKitSelectExisting,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  newKitImportTasks: {
    path: path.newKitImportTasks,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  emailTemplates: {
    path: path.emailTemplates,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.EMAIL_TEMPLATES,
  },
  eSignTemplates: {
    path: path.eSignTemplates,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.E_SIGN_TEMPLATES,
    pageContentOffsets: pageContentOffsets.notSet,
  },
  editESignTemplate: {
    path: path.editESignTemplate,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  listedKitDetails: {
    path: path.listedKitDetails,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  milestoneTemplateDetails: {
    path: path.milestoneTemplateDetails,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.MY_LISTEDKITS,
  },
  signDocument: {
    path: path.signDocument,
    scope: scope.PRIVATE,
    layout: layout.NONE,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  signDocumentSubmitted: {
    path: path.signDocumentSubmitted,
    scope: scope.PRIVATE,
    layout: layout.NONE,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  signDocumentGroup: {
    path: path.signDocumentGroup,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  signDocumentGroupSubmitted: {
    path: path.signDocumentGroupSubmitted,
    scope: scope.PRIVATE,
    layout: layout.NONE,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  clients: {
    path: path.clients,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.CLIENTS,
  },
  clientProfile: {
    path: path.clientProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.CLIENTS,
  },
  editClientProfile: {
    path: path.editClientProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.CLIENTS,
  },
  account: {
    path: path.account,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.SETTINGS,
  },
  editAccount: {
    path: path.editAccount,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.SETTINGS,
  },
  transactions: {
    path: path.transactions,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.TRANSACTIONS,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  newTransactionOptions: {
    path: path.newTransactionOptions,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  newTransactionScanComplete: {
    path: path.newTransactionScanComplete,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  newTransactionScanReview: {
    path: path.newTransactionScanReview,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  newTransaction: {
    path: path.newTransaction,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  editTransaction: {
    path: path.editTransaction,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  manageTransactionClients: {
    path: path.manageTransactionClients,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  confirmTransactionSigners: {
    path: path.confirmTransactionSigners,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  transactionTemplatedEmail: {
    path: path.transactionTemplatedEmail,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.TRANSACTIONS,
  },
  advancedFields: {
    path: path.advancedFields,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.ADVANCED_FIELDS,
  },
  integrations: {
    path: path.integrations,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.INTEGRATIONS,
  },
};

const clientPages = {
  onboarding: {
    path: path.onboarding,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    desktopLayout: layout.BOX,
    hideEmailVerificationToast: true,
    pageContentOffset: pageContentOffsets.withoutTop,
  },
  agentProfile: {
    path: path.agentProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTab: tabs.sideBarTabs.AGENT_PROFILE,
    tab: tabs.bottomTabs.MORE,
  },
  signDocument: {
    path: path.signDocument,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  signDocumentSubmitted: {
    path: path.signDocumentSubmitted,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  signDocumentGroup: {
    path: path.signDocumentGroup,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  signDocumentGroupSubmitted: {
    path: path.signDocumentGroupSubmitted,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
  editESignTemplate: {
    path: path.editESignTemplate,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
};

const coordinatorPages = {
  ...realtorPages,
  teams: {
    path: path.teams,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.TEAMS,
  },
  eSignTemplates: {
    path: path.eSignTemplates,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.E_SIGN_TEMPLATES,
    pageContentOffsets: pageContentOffsets.notSet,
  },
  teamMemberProfile: {
    path: path.teamMemberProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.TEAMS,
  },
  teamProfile: {
    path: path.teamProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.TEAMS,
  },
  editTeamMemberDetails: {
    path: path.editTeamMemberDetails,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.TEAMS,
  },
  editTeamProfile: {
    path: path.editTeamProfile,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.TEAMS,
  },
  auditTransaction: {
    path: path.auditTransaction,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    sideBarTabs: tabs.sideBarTabs.TRANSACTIONS,
    pageContentOffset: pageContentOffsets.notSet,
  },
  newEmailTemplate: {
    path: path.newEmailTemplate,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.EMAIL_TEMPLATES,
  },
  editEmailTemplate: {
    path: path.editEmailTemplate,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.EMAIL_TEMPLATES,
  },
  emailTemplatesFolder: {
    path: path.emailTemplatesFolder,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
  },
  editEmailTemplateInFolder: {
    path: path.editEmailTemplateInFolder,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
  },
};

const adminPages = {
  ...coordinatorPages,
  eSignTemplates: {
    path: path.eSignTemplates,
    scope: scope.PRIVATE,
    layout: layout.MAIN,
    tab: tabs.bottomTabs.MORE,
    sideBarTab: tabs.sideBarTabs.E_SIGN_TEMPLATES,
    pageContentOffsets: pageContentOffsets.notSet,
  },
  editESignTemplate: {
    path: path.editESignTemplate,
    scope: scope.PRIVATE,
    layout: layout.NONE,
    sideBarTab: tabs.sideBarTabs.E_SIGN_TEMPLATES,
  },
  closePage: {
    path: path.closePage,
    scope: scope.PRIVATE,
    layout: layout.NONE,
  },
};

export const isPublicPage = (pageUrl) => {
  const publicPagePaths = Object.values(getPublicPages(null)).map((pageData) => pageData.path);
  // true if pageUrl includes (fully or partially) any path from Public pages
  const isPublicPage = publicPagePaths.some((publicPath) => pageUrl.includes(publicPath));
  return isPublicPage;
};

export const configurations = (user, company) => {
  const pages = Object.values(getPublicPages(user));

  if (user) {
    pages.push(...Object.values(commonUserPages));

    const isRealtor = userHelpers.isRealtor(user);
    const isClient = userHelpers.isClient(user);
    const isCoordinator = userHelpers.isCoordinator(user);
    const isAdmin = userHelpers.isAdmin(user);

    if (isRealtor) {
      pages.push(...Object.values(realtorPages));
    }

    if (isClient) {
      pages.push(...Object.values(clientPages));
    }

    if (isCoordinator) {
      pages.push(...Object.values(coordinatorPages));
    }

    if (isAdmin) {
      pages.push(...Object.values(adminPages));
    }
  }

  return pages;
};
